import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Location } from '@angular/common';

import { Meta } from '@angular/platform-browser';

import { links } from './data';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink],
})
export class NotfoundComponent {
    private location = inject(Location);
    private meta = inject(Meta);

    protected initialized: boolean;

    constructor() {
        const link = links[window.location.pathname];
        if (link) {
            window.location.href = link;
            return;
        } else if (this.location.path() !== '/notfound') {
            this.location.replaceState('/notfound');
        } else {
            this.meta.addTags([{ name: 'robots', content: 'noindex' }], true);
        }
        this.initialized = true;
    }
}
